import script from "./PageBase.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageBase.vue?vue&type=script&lang=ts&setup=true"

import "./PageBase.vue?vue&type=style&index=0&id=562e87bc&lang=scss"

const __exports__ = script;

export default __exports__